<span>
  @if (displayIcon) {
    <svg-icon key="calendar" />
  }
  {{ formattedInterval }}</span
>
